import { render, staticRenderFns } from "./ksinfo.vue?vue&type=template&id=ec696a7e&scoped=true"
import script from "./ksinfo.vue?vue&type=script&lang=js"
export * from "./ksinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec696a7e",
  null
  
)

export default component.exports